import { put, select, take } from '@redux-saga/core/effects';
import ActionTypes from 'containers/Configurator/constants/furniture';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import {
  makeSelectCabinet,
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from 'containers/Configurator/selectors/furniture';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import { shelvesSelectionAction } from 'containers/Configurator/actions/selection';
import {
  switchShelfPositionFailure,
  updateCabinetSuccess,
} from 'containers/Configurator/actions/furniture';
import { makeSelectShelvesLevelSelected } from 'containers/Configurator/selectors/selection';
import _ from 'lodash';

export function* switchShelfPositionSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.CABINET_SWITCH_SHELF_REQUEST);
    const cabinetOrigin: Cabinet = yield select(makeSelectCabinet());
    const furniture: Furniture = yield select(makeSelectFurniture());
    const selectedIdCabinet = yield select(makeSelectSelectedIdCabinet());
    const cabinetNext = cabinetOrigin.clone();

    try {
      // Get payload
      const { level, positionChange } = payload;
      // Set action
      cabinetNext.moveShelfPosition(level, positionChange);

      yield put(shelvesSelectionAction([level + positionChange]));

      // Don't validate with rules if we only switch position
      const newFurniture = furniture.clone();
      newFurniture.replace(cabinetNext, selectedIdCabinet);
      yield put(updateCabinetSuccess(newFurniture, selectedIdCabinet));
    } catch (error) {
      yield put(switchShelfPositionFailure(error));
    }
  }
}

export function* navigationShelvesSaga() {
  // Go up or down
  while (true) {
    const { payload } = yield take(ActionTypes.NAVIGATE_SHELVES);
    const cabinet: Cabinet = yield select(makeSelectCabinet());
    const selectedShelfsLevel: number[] = yield select(
      makeSelectShelvesLevelSelected(),
    );

    if (selectedShelfsLevel.length === 0) {
      // If all shelves are selected, we ignore the move
      continue;
    }

    // Get payload
    const { direction } = payload;

    if (direction > 0) {
      // Move up
      const max = _.max(selectedShelfsLevel);
      if (max !== undefined && max < cabinet.shelves.length - 1) {
        yield put(shelvesSelectionAction([max + 1]));
      }
    } else {
      // Move down
      const min = _.min(selectedShelfsLevel);
      if (min !== undefined && min > 0) {
        yield put(shelvesSelectionAction([min - 1]));
      }
    }
  }
}
